import PageHeader from '../layout/PageHeader'
import { Search, Add } from '@mui/icons-material'
import {
  Card,
  CardHeader,
  CardContent,
  Typography,
  Grid,
  Button,
  Tabs,
  Tab,
} from '@mui/material'
import { useParams } from 'react-router'
import { faUserCircle } from '@fortawesome/free-solid-svg-icons'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import makeStyles from '@mui/styles/makeStyles'
import PageContainer from '../layout/PageContainer'
import PatientsDataPreview from './PatientsDataPreview'
import PatientEvents from './PatientEvents'
import axios from 'axios'
import { openPopup } from '../../../store/popupsSlice'
import { useEffect, useState } from 'react'
import { useDispatch, useSelector } from 'react-redux'
import { Link, useRouteMatch, useHistory } from 'react-router-dom'
import PatientNotes from './PatientNotes'
// import StoreKeyProvider from '../../providers/StoreKeyProvider'
// import WithFilters from '../../hocs/WithFilters'
// import DataTable from '../dataTable/DataTable'

const useStyles = makeStyles((theme) => ({
  fontAwesome: {
    position: 'absolute',
    fontSize: '16rem',
    right: '20%',
    margin: 'auto 0',
    top: '50%',
    transform: 'translateY(-50%);',
    height: '80%',
    color: theme.palette.primary.light,
    overflow: 'hidden',
    opacity: '0.5',
  },
  customCard: {
    position: 'relative',
  },
  custom: {
    width: '100%',
    maxWidth: '33.33% !important',
  },
}))

const tabNameToIndex = {
  0: 'results',
  1: 'events',
  2: 'notes',
}

const indexToTabName = {
  results: 0,
  events: 1,
  notes: 2,
}

function LinkTab(props) {
  return <Tab component={Link} {...props} />
}

const PatientsPreview = () => {
  const dispatch = useDispatch()

  const { id } = useParams([])
  const [patient, setPatient] = useState([])
  const user = useSelector((state) => state.user.user)
  const match = useRouteMatch()
  const history = useHistory([])
  const [tab, setTab] = useState(indexToTabName[match.params.page])

  useEffect(() => {
    if (id) {
      loadPatient(id)
    }
  }, [id])

  const loadPatient = (id) => {
    axios.post(`/patients/${id}`).then((res) => {
      if (res.status == 200) {
        setPatient(res.data)
      }
    })
  }

  const classes = useStyles()

  const handleTabChange = (event, newValue) => {
    history.push(`${tabNameToIndex[newValue]}`)
    setTab(newValue)
  }

  return (
    <>
      <PageHeader
        icon={<Search fontSize="large" />}
        title="Podgląd pacjenta"
        subtitle="Tutaj znajdziesz szczegóły na temat konkretnego pacjenta"
      />
      <PageContainer>
        {patient && id && (
          <>
            <Card className={classes.customCard} elevation={2} square>
              <FontAwesomeIcon
                className={classes.fontAwesome}
                icon={faUserCircle}
              />
              <CardHeader
                title={`${patient.firstname} ${patient.lastname}`}
                action={
                  user.role_id == 1 && (
                    <div className="flex justify-center items-center gap-4">
                      {/* <Button
                        startIcon={<Add />}
                        variant="contained"
                        color="primary"
                        onClick={() =>
                          dispatch(
                            openPopup({
                              component: 'PatientFactory',
                              title: 'Edytuj pacjenta',
                              level: 1,
                              // maxWidth: 'xl',
                              key: 'patient-factory-popup',
                              values: {
                                patient_id: patient.id,
                                patient_name: `${patient.firstname} ${patient.lastname}`,
                              },
                            })
                          )
                        }
                      >
                        Edytuj Pacjenta
                      </Button> */}
                      <Button
                        startIcon={<Add />}
                        variant="contained"
                        color="primary"
                        onClick={() =>
                          dispatch(
                            openPopup({
                              component: 'ContractFactory',
                              title: 'Dodaj zlecenie',
                              level: 1,
                              maxWidth: 'xl',
                              key: 'contract-factory-popup',
                              values: {
                                patient_id: patient.id,
                                patient_name: `${patient.firstname} ${patient.lastname}`,
                              },
                            })
                          )
                        }
                      >
                        Dodaj zlecenie
                      </Button>
                    </div>
                  )
                }
              ></CardHeader>
              <CardContent>
                <div>
                  <Card
                    elevation={0}
                    className="flex flex-col pt-0 text-black lg:w-full md:w-full p-4 whitespace-nowrap"
                  >
                    <Grid
                      container
                      rowSpacing={1}
                      columnSpacing={{ xs: 1, sm: 2, md: 3 }}
                    >
                      <Grid item xs={12} md={6} lg={4}>
                        <Typography variant="subtitle1">
                          Pesel: {patient.pesel}
                        </Typography>
                      </Grid>
                      <Grid item xs={12} md={6} lg={4}>
                        <Typography variant="subtitle1">
                          Data urodzenia: {patient.birth_date}
                        </Typography>
                      </Grid>
                      <Grid item xs={12} md={6} lg={4}>
                        <Typography variant="subtitle1">
                          E-mail: {patient.email}
                        </Typography>
                      </Grid>
                      <Grid item xs={12} md={6} lg={4}>
                        <Typography variant="subtitle1">
                          Numer telefonu: {patient.phone_number}
                        </Typography>
                      </Grid>
                      <Grid item xs={12} md={6} lg={4}>
                        <Typography variant="subtitle1">
                          Konto:{' '}
                          <span className="font-bold">
                            {patient.active ? 'aktywne' : 'nieaktywne'}
                          </span>
                        </Typography>
                      </Grid>
                      <Grid item xs={12} md={6} lg={4}>
                        <Typography variant="subtitle1">
                          Udostępnia lekarzowi:{' '}
                          <span className="font-bold">
                            {patient.share_with_doctor ? 'tak' : 'nie'}
                          </span>
                        </Typography>
                      </Grid>
                    </Grid>
                  </Card>
                </div>
              </CardContent>
            </Card>
            {user && user.role_id == 1 && (
              <Grid item xs={12}>
                <Card>
                  <Tabs
                    value={tab}
                    onChange={handleTabChange}
                    aria-label="nav tabs"
                  >
                    <LinkTab
                      label="Wyniki badań"
                      to="results"
                      className={classes.custom}
                    />
                    <LinkTab
                      label="Zdarzenia"
                      to="events"
                      className={classes.custom}
                    />
                    <LinkTab
                      label="Notatki"
                      to="notes"
                      className={classes.custom}
                    />
                  </Tabs>
                  <CardContent className="no-padding">
                    {tab === 0 && <PatientsDataPreview patientId={id} />}
                    {tab === 1 && <PatientEvents patientId={id} />}
                    {tab === 2 && <PatientNotes patientId={id} />}
                  </CardContent>
                </Card>
              </Grid>
            )}
          </>
        )}
        {user && user.role_id == 2 && <PatientsDataPreview patientId={id} />}
      </PageContainer>
    </>
  )
}

export default PatientsPreview
